<template>
  <v-list-item
      v-if="!hasChild && !route.hide && route.show"
      class="navbar-list-item"
      :to="route.to"
      exact
      link
      :class="'level-' + level"
      flat
      :active-class="'active-nav-item level-' + level"
      @click="routeClick(route)"
  >
    <v-list-item-icon v-if="route.icon">
      <v-icon class="navbar-icon">{{ route.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content class="pr-3">
      <v-list-item-title :class="'level-' + level">{{ route.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <v-list-group
      v-else-if="route.show && !route.hide"
      no-action
      :sub-group="subGroup"
      class="navbar-list-item"
      :class="'level-' + level"
      v-model="visible"
      :active-class="'active-nav-group'"
  >
    <template #activator>
      <v-list-item flat class="pr-0 my-0" :class="'level-' + level" exact>
        <v-list-item-icon v-if="route.icon">
          <v-icon class="navbar-icon">{{ route.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content class="pr-3">
          <v-list-item-title :class="'level-' + level">{{ route.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <navbar-list-item
        v-for="(child, i) in route.children"
        v-if="child.show"
        :key="`${level}-${i}`"
        :route="child"
        :sub-group="true"
        :level="level+1"
    />
  </v-list-group>
</template>

<script>
export default {
  name: "NavbarListItem",
  props: ["route", "subGroup", "level"],
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    hasChild() {
      return this.route.children && this.route.children.length;
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.EventBus.$emit("navbar:closeOthers", {
          route: this.route,
          level: this.level,
        });
      }
    },
  },
  beforeCreate() {
    this.$options.components.NavbarListItem = require("./NavbarListItem.vue").default;
  },
  created() {
    this.EventBus.$on("navbar:closeOthers", ({ route, level }) => {
      if (this.route.title != route.title && level <= this.level) {
        this.visible = false;
      }
    });
  },
  methods: {
    routeClick(route) {
      if (this.$route.name == route.to.name) {
        this.EventBus.$emit("sameRouteClick");
      }
      this.EventBus.$emit("close-mobile-drawer");

    },
  },
};
</script>

<style lang="scss" >
.navbar-list-item {
  border-radius: 0 !important;
  margin-bottom: 0px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.4) !important;
  }

  &:hover {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, transparent 100%) !important;

    .v-list-item__title,
    .navbar-icon {
      color: #E0E0E0 !important;
      text-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
    }
  }

  &.v-list-item--active,
  &.v-list-item--link:hover {
    border-left: 3px solid rgba(33, 150, 243, 0.3);

    .v-list-item__title {
      color: #ccfbf1 !important;
      font-weight: 600 !important;
      text-shadow: 0 0 10px rgba(33, 150, 243, 0.3);
    }

    .navbar-icon {
      color: #ccfbf1 !important;
    }
  }

  .level-1 {
    font-weight: 700 !important;
    color: #FFFFFF !important;
    font-size: 1rem !important;
    letter-spacing: 0.5px;
  }

  .level-2 {
    font-weight: 600 !important;
    color: #EEEEEE !important;
    font-size: 0.95rem !important;
  }

  .level-3 {
    font-weight: 500 !important;
    color: #E0E0E0 !important;
    font-size: 0.9rem !important;
  }

  // Text styling
  .v-list-item__title,
  .v-list-item__subtitle {
    white-space: normal !important;
    line-height: 1.3rem !important;
    transition: all 0.3s ease !important;
  }

  // Group items spacing
  .v-list-group__items > .v-list-item {
    padding-right: 0px !important;
    margin-right: 24px !important;
    background: rgba(0, 0, 0, 0.2) !important;

    &:hover {
      background: rgba(255, 255, 255, 0.03) !important;
    }
  }

  .v-list-group__header {
    margin-bottom: 0px !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  // Sub-group styling
  .v-list-group--sub-group {
    margin-right: 24px;
    background: rgba(0, 0, 0, 0.15) !important;

    .v-list-group__header {
      padding-right: 0px !important;
      background: rgba(0, 0, 0, 0.1) !important;
    }

    .v-list-group__items .v-list-item {
      padding-right: 0px !important;
      margin-right: 36px !important;
      background: rgba(0, 0, 0, 0.25) !important;

      &:hover {
        background: rgba(255, 255, 255, 0.04) !important;
      }

    }
  }

  .navbar-icon {
    font-size: 22px !important;
    width: 25px !important;
    height: 25px !important;
    transition: all 0.3s ease !important;

    svg {
      width: 100% !important;
      height: 100% !important;
      color: #B0BEC5 !important;
      transition: all 0.3s ease !important;
    }
  }

  .v-list-group--active {
    > .v-list-group__header {
      border-left: 2px solid #fff !important;

      .v-list-item__title {
        color: #fff !important;
      }

      .navbar-icon {
        color: #fff !important;
      }
    }
  }
}
</style>